/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { isErrorForm, handleValidarStrings, isNullOrEmpty, getDatePost } from '../../settings/utils'
import { defaultTypes } from "../../settings/enums";
import { 
    apiMedidasList, apiBuscarArticuloPorClaveMedida, apiListasCatalogosArticulos, apiArticuloSave, 
    apiObtenerCorridas, apiCargarArticuloPorClave, apiMedidasSave, apiCodigobarrasSave, 
    apiArticuloDeleteFullData, apiArticuloDeleteMedidaFullData, apiProveedoresPorArticulo, 
    apiEliminarTodasMedidasArticulo, apiIAInfoAprendizaje, apiIAAgragarVector, apiIAPredecir, 
    apiIASincronizarTodo, apiBuscararticulosFiltroFull 
} from "../../settings/ApiConfig";
import { useRequest } from "../System/RequestContext";
import { useLayout } from "../System/LayoutContext";
import { Forum } from "@mui/icons-material";

const getStructArticulos = () => ({
    fecharegistro:getDatePost(),
    clavearticulo: defaultTypes.String, 
    descripcion:defaultTypes.String,
    color:defaultTypes.String,
    factor:defaultTypes.double,
    presentacion:defaultTypes.String,
    marca:defaultTypes.String,
    fabricante:defaultTypes.String,
    material:defaultTypes.String,
    familia:defaultTypes.String,
    subfamilia:defaultTypes.String,
    ivaventa:defaultTypes.string,
    ivacompra:defaultTypes.string,
    status:"ACTIVO",
    porcentajeiva:defaultTypes.double,
    exentoiva:defaultTypes.String,
    imagen:defaultTypes.byteArray,
    codigocomun:defaultTypes.String,
});

const getStructArticulosPayload = () => ({
    fecharegistro:{value:getDatePost(),error:false,helper:defaultTypes.String},
    clavearticulo:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    descripcion:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    color:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    factor:{value:defaultTypes.double,error:false,helper:defaultTypes.String},
    presentacion:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    marca:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    fabricante:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    material:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    familia:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    subfamilia:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    ivaventa:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    ivacompra:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    status:{value:"ACTIVO",error:false,helper:defaultTypes.String},
    porcentajeiva:{value:defaultTypes.double,error:false,helper:defaultTypes.String},
    exentoiva:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
    imagen:{value:defaultTypes.byteArray,error:false,helper:defaultTypes.String},
    codigocomun:{value:defaultTypes.String,error:false,helper:defaultTypes.String},
});

const getMedidasStruct = () => ({
    fechaajuste:defaultTypes.Date,
    medida:defaultTypes.double,
    existencia:defaultTypes.double,
    formulario:defaultTypes.String,
    preciosugerido:defaultTypes.double,
    preciodefinitivo:defaultTypes.double,
    pmvb:defaultTypes.double,
    codigobarras:defaultTypes.String,
    cuc:defaultTypes.double
});

const getFormulario = () => ({
    clavearticulo: defaultTypes.String,
    formula: defaultTypes.String,
    preciosugerido: defaultTypes.double,
    preciodefinitivo: defaultTypes.double,
    pmvb: defaultTypes.double,
    corrida: defaultTypes.String,
});

export const ArticulosContext = createContext();
export const ArticulosProvider = (props) => {
    const { GetRequest, PostRequest, DeleteRequest } = useRequest();

    const { handleOpenAlert } = useLayout();

    const navigation = useNavigate();
    const [articuloSeleccionado, setArticuloSeleccionado] = useState(getStructArticulos());
    const [articuloPayLoad, setArticuloPayLoad] = useState(getStructArticulosPayload());

    const [medidasList, setMedidasList] = useState([]);
    
    const [medidaSeleccionada, setMedidaSeleccionada] = useState({});
    const [pendingSaveData, setPendingSaveData] = useState(null);
    const [openConfirmSaveModal, setOpenConfirmSaveModal] = useState(false);
    const [statusEditArticulo, setStatusEditArticulo] = useState(true); // está invertido por el uso en propiedades disabled de los componentes
    const [imagenBase64, setImagenBase64] = useState("");
    const [statusEditable, setStatusEditable] =  useState(false);

    const [listaPresentaciones , setListaPresentaciones] = useState([]);
    const [listaMarcas , setListaMarcas] = useState([]);
    const [listaProveedores , setListaProveedores] = useState([]);
    const [listaMateriales , setListaMateriales] = useState([]);
    const [listaFamilias , setListaFamilias] = useState([]);
    const [listaSubfamilias , setListaSubfamilias] = useState([]);
    const [listaColores , setListaColores] = useState([]);
    const [listaCorridas, setListaCorridas] = useState([]);
    
    const STORAGE_VERSION = 'v2';

    const getStoredCorrida = (key) => {
        try {
            const stored = localStorage.getItem(key);
            if (!stored) return "";
            const parsed = JSON.parse(stored);
            if (parsed.version !== STORAGE_VERSION) return "";
            return parsed.data;
        } catch {
            return "";
        }
    };

    const getStoredFormulario = (key) => {
        try {
            const stored = localStorage.getItem(key);
            if (!stored) return getFormulario();
            const parsed = JSON.parse(stored);
            if (parsed.version !== STORAGE_VERSION) return getFormulario();
            return parsed.data;
        } catch {
            return getFormulario();
        }
    };

    const [corridaSeleccionada, setCorridaSeleccionada] = useState(() => getStoredCorrida('articulo_corrida'));
    const [formularioMedidas, setFormularioMedidas] = useState(() => getStoredFormulario('articulo_formulario'));

    const [listaProveedoresArticulo , setListaProveedoresArticulo] = useState([]);

    const [statusBuscarArticuloSimple, setStatusBuscarArticuloSimple] = useState(false);
    const [statusOpenCodigoBarras, setStatusOpenCodigoBarras] = useState(false);
    const [statusOpenModalEliminarMedidas, setStatusOpenModalEliminarMedidas] = useState(false);
    const [statusOpenModalEliminarTodasMedidas, setStatusOpenModalEliminarTodasMedidas] = useState(false);
    const [statusOpenModalEliminarArticulo, setStatusOpenModalEliminarArticulo] = useState(false);
    const [infoAprendizajeArticulo, setInfoAprendizajeArticulo] = useState(null);
    const [statusIALoading, setStatusIALoading] = useState(false);
    const [listaArticulosFull, setListaArticulosFull] = useState([]);

    useEffect(() => {
        if (corridaSeleccionada && corridaSeleccionada.trim() !== "") {
            localStorage.setItem('articulo_corrida', JSON.stringify({ version: STORAGE_VERSION, data: corridaSeleccionada }));
        } else {
            localStorage.removeItem('articulo_corrida');
        }
    }, [corridaSeleccionada]);

    useEffect(() => {
        localStorage.setItem('articulo_formulario', JSON.stringify({ version: STORAGE_VERSION, data: formularioMedidas }));
    }, [formularioMedidas]);

    function bytesToBase64(bytes) {
        let binary = '';
        let len = bytes.length;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    const handleClickRegresarMainDashboard = () => {
        const route = "/*";
        navigation(route);
    };

    const handleObtenerCatalogosArticulos= async()=>{
        const url = apiListasCatalogosArticulos
        const result = await GetRequest({
            url,
            loader:"Se están cargando los catálogos de artículos a combos..."
        });

        if(result.hasError)
        {
            handleOpenAlert("Error al obtener catálogos de artículos actuales: " + result.message);
            return;
        }

        setListaColores(result?.result?.listacolores);
        setListaPresentaciones(result?.result?.listapresentaciones);
        setListaMarcas(result?.result?.listamarcas);
        setListaProveedores(result?.result?.listaproveedores ?? []);
        setListaMateriales(result?.result?.listamateriales);
        setListaFamilias(result?.result?.listafamilias);
        setListaSubfamilias(result?.result?.listasubfamilias);        
    };

    const handleChangeArticulosSeleccionado = (e) => {
        setArticuloSeleccionado((prev) => ({ ...prev, ...e }));
    };

    const handleClickNuevoArticulo=()=>{
        handleClickDeshacer()
        setArticuloSeleccionado(getStructArticulos());
        setMedidasList(getMedidasStruct());
        setMedidaSeleccionada({});
        setStatusEditArticulo(false); //Falso para que habilite los disables de los objetos
    };

    const handleClickGuardarArticulo=async()=>{
        
        if (articuloPayLoad.descripcion.value.trim().length == 0 
                || articuloPayLoad.factor.value == 0 
                || articuloPayLoad.familia.value.trim().length == 0
                || articuloPayLoad.subfamilia.value.trim().length == 0
                || articuloPayLoad.presentacion.value.trim().length == 0
        ) {
            handleOpenAlert("Es necesario especificar datos requeridos para continuar!");
            return;
        };

        if (isErrorForm(articuloPayLoad)) {
            handleOpenAlert("Existen errores en los datos del artículo y no es posible continuar!");
            return;
        };

        if (articuloPayLoad.imagen.value) {
            setArticuloPayLoad({
                ...articuloPayLoad,
                imagen: "",
            });
        }

        const resultPayload = {};

        const upperIfString = (v) =>
        typeof v === "string" ? v.toUpperCase() : v;

        Object.entries(articuloPayLoad).forEach(([key, meta]) => {
        // Si el campo es un objeto tipo { value, error, helper }
        if (meta && typeof meta === "object" && "value" in meta) {
            resultPayload[key] = upperIfString(meta.value);
        } else {
            // Por si algún día hay algo distinto
            resultPayload[key] = upperIfString(meta);
        }
        });

        await setArticuloSeleccionado(resultPayload);
        const payload = {
            ...resultPayload,
            imagen: bytesToBase64(articuloPayLoad.imagen.value),
            listaproveedores:listaProveedoresArticulo.map(f => ({
                claveproveedor: f.clavefabricante,
                razonsocial: f.nombrefabricante,
                clavearticuloproveedor: f.clavearticulofabricante,
                status: f.status
            }))
        };

        const result = await PostRequest({
            url:apiArticuloSave,
            body:payload,
            loader:"Se está salvando artículo en sistema..."
        });

        if (result.hasError || result.errors)
        {
            handleOpenAlert("Error al salvar artículo en sistema");
            return;
        }

        if (result?.result)
            handleOpenAlert("Proceso correcto de salvar datos", "ok");
        else
        {
            handleOpenAlert("Existe un problema en la función de salvar datos de artículo");
        }        

        const articulo = result?.result.articulo;
        const medidas = result?.result.medidas;

        setArticuloSeleccionado(articulo);
        setMedidasList(medidas);
        setStatusEditArticulo(true);

        setFormularioMedidas((prev) => ({
            ...prev,
            clavearticulo: articulo?.clavearticulo.trim().toUpperCase()
        }));
    };

    const handleClickGuardarCodigoBarras=async(codigobarras)=>{
        if (articuloSeleccionado.descripcion.trim().length == 0 
            || articuloSeleccionado.clavearticulo.trim().length == 0
            || medidaSeleccionada.medida == 0
        ) {
            handleOpenAlert("Es necesario especificar datos requeridos para continuar!");
            return;
        };

        let url = apiCodigobarrasSave.replace("{clavearticulo}", articuloSeleccionado.clavearticulo.trim()).replace("{medida}", medidaSeleccionada.medida).replace("{codigobarras}", codigobarras.trim());

        const result = await PostRequest({
            url,
            loader:"Se está actualizando el código de barras en en sistema..."
        });

        if (result.hasError || result.errors)
        {
            handleOpenAlert("Error al actualizar el código de barras del artículo: " + result.message);
            return;
        }

        if (result?.result)
            handleOpenAlert("Proceso correcto en actualización de código de barras", "ok");
        else
        {
            handleOpenAlert("Existe un problema en la función de actualización del código de barras");
        }        

       await handleObtenerArticuloByClave(articuloSeleccionado.clavearticulo.trim());
       setStatusEditArticulo(false);
    };

    const handleObtenerArticuloByClave = async(clave, cargarFabricantes = false)=>{
        
        let url = apiCargarArticuloPorClave.replace("{clavearticulo}", clave.trim().toUpperCase())
        const response = await GetRequest({
            url,
            loader: "Obteniendo datos de artículo por clave",
        });

        if (response.hasError) {
            return;
        }

        if(response?.result <= 0)
        {
            return;
        }

        const articulo = response?.result.articulo;
        const medidas = response?.result.medidas;

        setImagenBase64(base64ToReaderResult(response?.result.articulo.imagen));
        setArticuloSeleccionado(response?.result.articulo);
        setMedidasList(response?.result.medidas);

        setFormularioMedidas((prev) => ({
            ...prev,
            clavearticulo: response?.result.articulo.clavearticulo
        }));
        
        setStatusEditArticulo(true);

        if(cargarFabricantes)
        {
            await handleObtenerFabricantesArticulo(response?.result.articulo.clavearticulo);
        }
        return articulo;
    };

    const handleBuscarArticuloFullData = async (clavearticulo, medida) => {
        const url = apiBuscarArticuloPorClaveMedida.replace("{clavearticulo}", clavearticulo.trim()).replace("{medida}", medida);
        const response = await GetRequest({
          url,
          alert: "Buscando artículo por código de barras"
        });
    
        if(response.hasError)
        {
          return;
        }
        return response?.result;
    };

    const handleCargarDatosArtículo=(data)=>{
        
        setCorridaSeleccionada("");
        handleObtenerArticuloByClave(data.clavearticulo);
    };

    const handleChangeDataArticulo = async (event, newValue, fieldName) => {
        // Caso 1: TextField
        if (event?.target?.name) {
            const { name, value } = event.target;
            if (name) {
                setArticuloSeleccionado(prev => ({
                    ...prev,
                    [name]: value
                }));
            }
            return;
        }

        // Caso 2: Autocomplete (desde AutoCompleteTools)
        if (newValue !== null && fieldName) {
            const value = typeof newValue === "string"
                ? newValue
                : newValue?.[fieldName] || ""; // evita undefined

            setArticuloSeleccionado(prev => ({
                ...prev,
                [fieldName]: value
            }));
        }
    };

    const handleChangeDataArticuloPayload = async (e, valor, field) => {
        let name = field ? field : e.target.name ?? "";
        let value = valor ? valor : e.target.value ?? "";
        let error = false;
        let helper = "";

        // 1) Validación básica de vacío
        if (!value) {
            error = true;
            helper = "El valor no puede ir vacío.";
        }

        // 2) Caracteres no permitidos
        const mensajeError = handleValidarStrings(value, name); 
        if (mensajeError) {          
            error = true;
            helper = mensajeError;   
        }

        // 3) Check muy sencillo anti-XSS / inyección (no es bala de plata)
        const lower = value.toLowerCase();
        if (
            !error &&
            (lower.includes("<script") ||
            lower.includes("</script") ||
            lower.includes("javascript:") ||
            lower.includes("onerror=") ||
            lower.includes("onload="))
        ) {
            error = true;
            helper = "Intento de inyección detectado y bloqueado en: (" + name + ")";
        }

        setArticuloPayLoad((prev) => ({
            ...prev,
            [name]: {
            ...prev[name],
            value,
            error,
            helper,
            },
        }));
    };

    const handleChangeMedidaSeleccionada=(e)=>{
        setFormularioMedidas({...formularioMedidas,
            cuc:e.cuc,
            formula:e.formulario,
            preciosugerido:e.preciosugerido,
            preciodefinitivo:e.preciodefinitivo,
            pmvb:e.pmvb,
        });
        setMedidaSeleccionada(e);
    };

    const handleUploadImage = (event) => {
        const files = event?.target?.files;
        if (!files || files.length === 0) return;

        const file = files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            const result = reader.result;
            if (!result) return;

            const base64 = result.split(',')[1];
            const binary = atob(base64);
            const byteArray = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
            byteArray[i] = binary.charCodeAt(i);
            }

            // Actualiza el estado
            setArticuloSeleccionado(prev => ({
            ...prev,
            imagen: Array.from(byteArray)
            }));

            setImagenBase64(reader.result); // Para mostrar el preview si gustas
        };

        reader.readAsDataURL(file);
    };

    function base64ToReaderResult(base64, mimeType = "image/png") {
        if (!base64 || typeof base64 !== "string") return null;
        return `data:${mimeType};base64,${base64}`;
    }

    const handleChangeFormulario = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setFormularioMedidas((prev) => {
            let nuevoEstado = {
            ...prev,
            [name]: value,
            };

            if (name === "formula") {
                try {
                    if (/^[0-9+\-*/().\s]+$/.test(value)) {
                        const resultado = parseFloat(eval(value));
                        nuevoEstado.preciosugerido = !isNaN(resultado) && isFinite(resultado) ? resultado : 0;
                    }
                } catch (err) {
                    nuevoEstado.preciosugerido = 0;
                }
            }

            return nuevoEstado;
        });

        setStatusEditArticulo(false);
    };

    const handleObtenerCorridas=async()=>{
        const result = await GetRequest({
            url:apiObtenerCorridas,
            loader:"Se están obteniendo las corridas del sistema..."
        });

        if(result.hasError)
        {
            handleOpenAlert("Error al obtener la lista de corridas del sistema...");
            return;
        }

        const corridas = Array.isArray(result?.result) ? result.result : [];
        setListaCorridas([
            { descripcion: "-- Selecciona --", medidainicial: 0, medidafinal: 0, intervalos: 0, fecharegistro: Date.now() },
            ...corridas
        ]);
    };

    const handleChangeCorridas = (event, newValue) => {
        const valor =
            typeof newValue === "string"
            ? newValue
            : newValue?.descripcion || "";

        setCorridaSeleccionada(valor);
        setFormularioMedidas(prev => ({
            ...prev,        
            corrida: valor,             
        }));
        setStatusEditArticulo(false);
    };

    const handleAbrirBuscarArticulo =()=>{
        setStatusBuscarArticuloSimple(true);
    };    

    const handleCerrarBuscarArticulo=()=>{
        setStatusBuscarArticuloSimple(false);
    };

    const handleClickRefrescarDatos=async()=>{
        if (!articuloSeleccionado.clavearticulo)
            {
                handleClickDeshacer();
                return;
            }
        
        handleObtenerArticuloByClave(articuloSeleccionado.clavearticulo)
    };

    const handleClickEditarArticulo =()=>{
        setStatusEditArticulo(false);
    };

    const handleClickDeshacer = () => {
        setArticuloSeleccionado(getStructArticulos());
        setMedidasList(getMedidasStruct());
        setMedidaSeleccionada({});
        setImagenBase64("");
        setStatusEditArticulo(true);
        setListaProveedoresArticulo([]);
        setCorridaSeleccionada("");
        setFormularioMedidas(getFormulario());
    };

    const handleClonarArticulo = () => {
        if (!articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "") {
            handleOpenAlert("No hay artículo cargado para clonar");
            return;
        }

        setArticuloPayLoad((prev) => ({
            ...prev,
            clavearticulo: {
                ...prev.clavearticulo,
                value: "",
                error: false,
                helper: "",
            }
        }));

        setArticuloSeleccionado((prev) => ({
            ...prev,
            clavearticulo: "",
        }));

        setMedidasList([]);
        setMedidaSeleccionada({});

        setStatusEditArticulo(false);
        handleOpenAlert("Artículo clonado. Complete la clave y guarde las nuevas medidas.", "ok");
    };

    const handleConfirmarRegistrarMedidas = async () => {
        if (!pendingSaveData) return;

        if (!pendingSaveData.clavearticulo || pendingSaveData.clavearticulo.trim() === "") {
            handleOpenAlert("Error: No se puede guardar la medida sin una clave de artículo. Guarde primero el artículo.");
            setOpenConfirmSaveModal(false);
            setPendingSaveData(null);
            return;
        }

        const result = await PostRequest({
            url: apiMedidasSave,
            loader:"Se está realizando el proceso de guardado de la corrida...",
            body: pendingSaveData,
        });

        setOpenConfirmSaveModal(false);
        setPendingSaveData(null);

        if (result.hasError || result.errors)
        {
            handleOpenAlert("Error al guardar datos de corrida");
            return;
        }

        if (articuloSeleccionado.clavearticulo && articuloSeleccionado.clavearticulo.trim() !== "") {
            await handleObtenerArticuloByClave(articuloSeleccionado.clavearticulo);
            setStatusEditArticulo(false);
        }

        handleOpenAlert("Medida guardada correctamente", "ok");
    };

    const handleRegistrarMedidas = async()=>{
        if (statusEditArticulo) {
            handleOpenAlert("Debe activar el modo edición para guardar medidas.");
            return;
        }

        if (!articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "") {
            handleOpenAlert("No hay artículo seleccionado para guardar las corridas. Guarde primero el artículo.");
            return;
        }

        if (!formularioMedidas.corrida || formularioMedidas.corrida.trim() === "") {
            handleOpenAlert("Seleccione una corrida antes de guardar.");
            return;
        }

        const dataToSend = {
            ...formularioMedidas,
            clavearticulo: articuloSeleccionado.clavearticulo.trim().toUpperCase(),
            corrida: formularioMedidas.corrida ? formularioMedidas.corrida.trim() : "",
        };

        setPendingSaveData(dataToSend);
        setOpenConfirmSaveModal(true);
    };

    const handleClickEliminarArticulo=async()=>{
        if(articuloSeleccionado.clavearticulo.trim().length === 0) return;

        const url = apiArticuloDeleteFullData.replace("{clavearticulo}",articuloSeleccionado.clavearticulo.trim());

        const result = await PostRequest({
            url,
            loader:"Se está eliminando toda la información del artículo actual..."
        });

        if(result.hasError)
        {
            handleOpenAlert("Error al eliminar toda la información del artículo");
            return;
        }

        handleOpenAlert("Artículo eliminado correctamente", "ok");
        setStatusOpenModalEliminarArticulo(false);
        handleClickDeshacer();
    };

    const handleClickEliminarMedidaArticulo=async()=>{
        if(articuloSeleccionado.clavearticulo.trim().length === 0) return;
        if(medidaSeleccionada.medida === 0) return;

        const url = apiArticuloDeleteMedidaFullData.replace("{clavearticulo}",articuloSeleccionado.clavearticulo.trim()).replace("{medida}", medidaSeleccionada.medida);

        const result = await PostRequest({
            url,
            loader:"Se está eliminando toda la información de la medida del artículo actual..."
        });

        if(result.hasError)
        {
            handleOpenAlert("Error al eliminar toda la información dela medida del artículo");
            return;
        }

        handleOpenAlert("Medida eliminada correctamente", "ok");
        await handleObtenerArticuloByClave(articuloSeleccionado.clavearticulo);
        setStatusEditArticulo(false);
        setStatusOpenModalEliminarMedidas(false);
    };

    const handleClickEliminarTodasMedidasArticulo = async () => {
        if (!articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim().length === 0) return;

        const url = apiEliminarTodasMedidasArticulo.replace("{clavearticulo}", articuloSeleccionado.clavearticulo.trim());

        const result = await PostRequest({
            url,
            loader: "Eliminando todas las medidas, existencias y movimientos del artículo..."
        });

        if (result.hasError)
        {
            handleOpenAlert("Error al eliminar todas las medidas del artículo: " + result.message);
            return;
        }

        handleOpenAlert("Todas las medidas eliminadas correctamente (existencias y movimientos borrados)", "ok");
        setMedidasList([]);
        setMedidaSeleccionada({});
        setCorridaSeleccionada("");
        setStatusEditArticulo(false);
        setStatusOpenModalEliminarTodasMedidas(false);
    };

    const handleObtenerFabricantesArticulo=async(clavearticulo)=>{
        
        if(clavearticulo == null || clavearticulo.length == 0) return;

        const url = apiProveedoresPorArticulo.replace("{clavearticulo}", clavearticulo.trim());

        const result = await GetRequest({
            url,
            loader:"Se está obteniendo la lista de Proveedores con sus estatus para el artículo..."
        });

        if (result.hasError)
        {
            handleOpenAlert("Error al obtener los proveedores asignados del artículo: " + result.message);
            return;
        }

        setListaProveedoresArticulo((result?.result.listaproveedores ?? []).map(p => ({
            clavefabricante: p.claveproveedor,
            nombrefabricante: p.razonsocial,
            clavearticulofabricante: p.clavearticuloproveedor,
            status: p.status
        })));
    };

    const handleObtenerMedidasArticulos= async(clavearticulo)=>{
        
        if (clavearticulo === null || clavearticulo === undefined) return;

        const url = apiMedidasList.replace("{clavearticulo}", clavearticulo)
        const result = await GetRequest({
            url,
            loader:"Se está cargando la lista de medidas del artículo..."
        });

        if(result.hasError)
        {
            handleOpenAlert("Error al obtener las medidas del artículo: " + result.message);
            return [];
            return;
        }
        
        return result?.result ?? [];
    };

    const handleIAObtenerInfoAprendizaje = async (clave) => {
        const claveLimpia = clave?.trim().toUpperCase() || "";
        const url = claveLimpia
            ? apiIAInfoAprendizaje.replace("{claveArticulo?}", encodeURIComponent(claveLimpia))
            : apiIAInfoAprendizaje.replace("/{claveArticulo?}", "");
        const result = await GetRequest({
            url,
            loader: "Obteniendo información de aprendizaje de la IA..."
        });

        if (result.hasError) return null;

        if (claveLimpia) {
            setInfoAprendizajeArticulo(result.result?.[0] || null);
        }
        return result.result;
    };
    const handleIAEntrenarArticulo = async () => {
        if (!articuloSeleccionado.clavearticulo || !imagenBase64) {
            handleOpenAlert("Es necesario tener un artículo cargado con imagen para entrenar la IA");
            return;
        }

        const payload = {
            clavearticulo: articuloSeleccionado.clavearticulo,
            descripcion: articuloSeleccionado.descripcion,
            imagen: imagenBase64.split(',')[1] // Solo el base64 sin el prefijo data:image/...
        };

        const result = await PostRequest({
            url: apiIAAgragarVector,
            body: payload,
            loader: "Generando vectores de entrenamiento en la IA..."
        });

        if (result.hasError) {
            handleOpenAlert("Error al entrenar artículo: " + result.message);
            return;
        }

        handleOpenAlert("Artículo entrenado correctamente en la IA", "ok");
        await handleIAObtenerInfoAprendizaje(articuloSeleccionado.clavearticulo);
    };

    const handleIASincronizarTodo = async () => {
        setStatusIALoading(true);
        const result = await PostRequest({
            url: apiIASincronizarTodo,
            loader: "Iniciando sincronización masiva de vectores de IA. Esto puede tardar varios minutos..."
        });

        setStatusIALoading(false);
        if (result.hasError) {
            handleOpenAlert("Error en sincronización masiva: " + result.message);
            return;
        }

        handleOpenAlert("Sincronización masiva completada: " + result.result.mensaje, "ok");
    };

    const handleIAPredecir = async (imgBase64) => {
        const result = await PostRequest({
            url: apiIAPredecir,
            body: imgBase64.split(',')[1],
            loader: "La IA está reconociendo el artículo..."
        });

        if (result.hasError) {
            handleOpenAlert("La IA no pudo reconocer el artículo: " + result.message);
            return null;
        }

        return result.result;
    };

    const handleJalarArticulosList = async (busqueda = "", inicio = 0, total = 50) => {
        let busq = busqueda.trim().length === 0 ? "TODO" : busqueda.trim();
        const url = apiBuscararticulosFiltroFull
            .replace("{busqueda}", busq)
            .replace("{registroinicial}", inicio)
            .replace("{totalregistros}", total);

        const result = await GetRequest({
            url,
            loader: "Buscando artículos..."
        });

        if (result.hasError) return;

        setListaArticulosFull(result?.result ?? []);
    };

    return (
        <ArticulosContext.Provider
            value={{               
                articuloSeleccionado,
                getMedidasStruct,
                medidasList,
                statusEditArticulo, setStatusEditArticulo,
                listaPresentaciones,
                listaMarcas,
                listaProveedores,
                listaMateriales,
                listaFamilias,
                listaSubfamilias,
                listaColores,
                medidaSeleccionada, setMedidaSeleccionada,
                handleChangeArticulosSeleccionado,
                handleClickRefrescarDatos,
                handleClickRegresarMainDashboard,
                handleClickNuevoArticulo,
                handleClickEditarArticulo,
                handleClickGuardarArticulo,
                handleClickEliminarArticulo,
                handleChangeDataArticulo,
                handleChangeDataArticuloPayload,
                handleChangeMedidaSeleccionada,
                handleObtenerCatalogosArticulos,
                handleUploadImage,
                imagenBase64, setImagenBase64,
                formularioMedidas, setFormularioMedidas, handleChangeFormulario,
                handleObtenerCorridas, 
                listaCorridas, 
                corridaSeleccionada, 
                handleChangeCorridas,
                statusBuscarArticuloSimple,
                handleAbrirBuscarArticulo, 
                handleCerrarBuscarArticulo,
                handleCargarDatosArtículo,
                handleObtenerArticuloByClave,
                handleClickDeshacer,
                handleClonarArticulo,
                handleRegistrarMedidas,
                handleConfirmarRegistrarMedidas,
                pendingSaveData,
                openConfirmSaveModal,
                setOpenConfirmSaveModal,
                statusEditable, setStatusEditable,
                handleClickGuardarCodigoBarras,
                handleClickEliminarMedidaArticulo,
                handleClickEliminarTodasMedidasArticulo,
                statusOpenCodigoBarras, setStatusOpenCodigoBarras,
                statusOpenModalEliminarMedidas, setStatusOpenModalEliminarMedidas,
                statusOpenModalEliminarTodasMedidas, setStatusOpenModalEliminarTodasMedidas,
                statusOpenModalEliminarArticulo, setStatusOpenModalEliminarArticulo,
                listaProveedoresArticulo, setListaProveedoresArticulo,
                articuloPayLoad, setArticuloPayLoad, getStructArticulosPayload,
                handleBuscarArticuloFullData,
                handleObtenerMedidasArticulos,
                handleIAObtenerInfoAprendizaje,
                handleIAEntrenarArticulo,
                handleIASincronizarTodo,
                handleIAPredecir,
                handleJalarArticulosList,
                listaArticulosFull,
                infoAprendizajeArticulo,
                statusIALoading,
            }}
        >
            {props.children}
        </ArticulosContext.Provider>
    );
};

export const useArticulos = () => useContext(ArticulosContext);
